import { useEffect } from 'react';

import { isPageReachBottom } from '@utils/Util';

const usePagination = (stateRef, pageAbleResponse, setDataList, setPage) => {
	useEffect(() => {
		if (pageAbleResponse?.data) {
			if ((pageAbleResponse.currentPage ?? 0) > 0) {
				const latestProducts = [...(stateRef.current.data ?? []), ...pageAbleResponse.data];
				setDataList(latestProducts);
				stateRef.current = {
					...pageAbleResponse,
					data: latestProducts
				};
			} else {
				stateRef.current = pageAbleResponse;
				setDataList(pageAbleResponse.data);
			}
		}
	}, [pageAbleResponse]);

	const handleBottomReached = () => {
		const { totalElements, currentPage, data } = stateRef.current;
		if (isPageReachBottom() && totalElements && totalElements > 0 && totalElements !== data?.length) {
			setPage((currentPage ?? 0) + 1);
		}
	};

	useEffect(() => {
		document.addEventListener('scroll', handleBottomReached);
		return () => {
			document.removeEventListener('scroll', handleBottomReached);
		};
	}, []);
};

export default usePagination;
